module.exports = __webpack_public_path__ + "img/28.7e4a60a7.svg";